import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-black/40 border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center" data-testid="navbar-logo">
            <img
              src="https://customer-assets.emergentagent.com/job_web-builder-418/artifacts/ge0fxx2x_Lucentis%20Logo.png"
              alt="LucentisIQ"
              className="h-24 w-auto"
              style={{ mixBlendMode: 'screen' }}
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection("features")}
              className="text-slate-300 hover:text-white transition-colors font-body text-sm"
              data-testid="nav-features-link"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection("why-us")}
              className="text-slate-300 hover:text-white transition-colors font-body text-sm"
              data-testid="nav-why-us-link"
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="px-6 py-2.5 rounded-full bg-gradient-to-r from-pink-500 to-lime-500 text-black font-bold hover:shadow-[0_0_20px_rgba(236,72,153,0.5)] transition-all duration-300"
              data-testid="nav-contact-cta"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
